<template>
<div class="chapter">
<div class="inner_page">
<div class="" data-pdf-bookmark="Part I. Meet the Team . . ." data-type="part" epub:type="part" id="d1e884"><h1 class="PartTitlept"><span href="#/toc01" title="Link target outside of Sample">Meet the Team . . .</span></h1><h1 class="PartTitlept"><span href="#/toc01" title="Link target outside of Sample">THE DIAMONDS ARE OUR WORLD’S BEST FRIENDS.</span></h1><figure class="Illustrationholderill customimage"><div class="figure"><img alt="Diamond.png" src="Diamond.jpg"/></div></figure>
<p class="Head-Level-1h1">Meet the Diamonds . . .</p><blockquote>
<p class="Extract-NoIndentext1">MICHELLE is always blowing bubbles, but best not stand too close when they start bursting. She’s</p>
<p class="Extract-NoIndentext1">THE AMAZING BUBBLES!</p>
<p class="Extract-NoIndentext1">Michelle LaFleur</p>
<p class="Extract-NoIndentext1">New York, New York</p></blockquote>
<p class="SpaceBreak-PrintOnlypo">* * *</p><blockquote>
<p class="Extract-NoIndentext1">HOWARD is the man that Jetboy would have been. He’s seen <em>The Jolson Story,</em> but his own tale is just beginning. Make way for</p>
<p class="Extract-NoIndentext1">JETMAN!</p>
<p class="Extract-NoIndentext1">Howard Hawkwood</p>
<p class="Extract-NoIndentext1">Philadelphia, Pennsylvania</p></blockquote>
<p class="SpaceBreak-PrintOnlypo">* * *</p><blockquote>
<p class="Extract-NoIndentext1">IVAN is full of surprises. Like Mother Russia, the more you pound on him, the more you have to deal with. He’s</p>
<p class="Extract-NoIndentext1">MATRYOSHKA!</p>
<p class="Extract-NoIndentext1">Ivan Kazakova</p>
<p class="Extract-NoIndentext1">Brighton Beach, New York</p></blockquote>
<p class="SpaceBreak-PrintOnlypo">* * *</p><blockquote>
<p class="Extract-NoIndentext1">MEGAN was dirt-poor growing up, but now she’s learned to shine. A regular diamond in the rough is our</p>
<p class="Extract-NoIndentext1">TIFFANI!</p>
<p class="Extract-NoIndentext1">Megan McKnee</p>
<p class="Extract-NoIndentext1">Boone, West Virginia</p></blockquote>
<p class="SpaceBreak-PrintOnlypo">* * *</p><blockquote>
<p class="Extract-NoIndentext1">JOE be nimble, Joe be quick, Joe can snatch your candlestick. You better bring your best game if you want to go one-on-one with</p>
<p class="Extract-NoIndentext1">JOE TWITCH!</p>
<p class="Extract-NoIndentext1">Joe Moritz</p>
<p class="Extract-NoIndentext1">Baltimore, Maryland</p></blockquote>
<p class="SpaceBreak-PrintOnlypo">* * *</p><blockquote>
<p class="Extract-NoIndentext1">EMILY is the fastest grrl on wheels. Don’t blink, or you’ll miss her whizzing by. There, that’s her, that</p>
<p class="Extract-NoIndentext1">BLRR!</p>
<p class="Extract-NoIndentext1">Emily Paige</p>
<p class="Extract-NoIndentext1">Sunnyvale, California</p></blockquote>
<p class="SpaceBreak-PrintOnlypo">* * *</p><blockquote>
<p class="Extract-NoIndentext1">Don’t you dare call RAJ handicapped. His servants wouldn’t take kindly to it. Step aside and clear a path for</p>
<p class="Extract-NoIndentext1">THE MAHARAJAH!</p>
<p class="Extract-NoIndentext1">Raj Chaturvedi</p>
<p class="Extract-NoIndentext1">Seattle, Washington</p></blockquote></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part01.vue?382b1511